var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-select',_vm._b({attrs:{"options":_vm.countriesList,"show-search":""},on:{"change":_vm.emitnow}},'a-select',_vm.modelValue,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }